import styled from 'styled-components';

import BaseSpinner from 'components/Icons/Spinner';

export const Spinner = styled(BaseSpinner)`
  position: absolute;
  left: 5px;
`;
